import React, {forwardRef, MouseEvent} from 'react';

import {useAppDispatch} from '../../../helpers/reduxHelpers';
import {pushPathAction} from '../../../store/panels/app/appPanelRouteActions';
import {getFirstAppPanelId} from '../../../store/panels/panelsSelectors';

/*
 * Props.
 */

export interface DefaultLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
}

/*
 * Component.
 */

export const DefaultLink = forwardRef<HTMLAnchorElement, DefaultLinkProps>((props, ref) => {
  const {to, onClick, ...otherProps} = props;
  const dispatch = useAppDispatch();

  const onClickHandler = (event: MouseEvent<HTMLAnchorElement>) => {
    try {
      if (onClick) {
        onClick(event);
      }
    } catch (ex) {
      event.preventDefault();
      throw ex;
    }

    if (event.defaultPrevented) {
      // onClick prevented default.
      return;
    }

    if (event.button !== 0) {
      // Ignore things other than left clicks.
      return;
    }

    if (isModifiedEvent(event)) {
      // Ignore clicks with modifier keys.
      return;
    }

    event.preventDefault();

    // TODO: Find a better way to get a panel ID in here.
    dispatch((dispatchParam, getState) => {
      const appPanelId = getFirstAppPanelId(getState());
      dispatchParam(pushPathAction(appPanelId, to));
    });
  };

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a {...otherProps} ref={ref} href={to} onClick={onClickHandler} />;
});

/*
 * Helpers.
 */

function isModifiedEvent(event: MouseEvent<HTMLAnchorElement>) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
